import queryString from 'query-string';

export default function(hashName)
{
    return {
        get()
        {
            const parsedHash = queryString.parse(this.$route.hash);

            if(parsedHash[hashName] === undefined)
                return 0;
            else
                return parseInt(parsedHash[hashName]);
        },
        set(val)
        {
            const cleaned = document.URL.replace(/#.*$/, '');
            window.location.replace(`${cleaned}#${hashName}=${val}`);
        }
    }
}
